// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  max-width: 900px;
  margin: 0 auto;
}

.header {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  padding: 20px 30px;
  margin-bottom: 20px;
}

.header h1 {
  color: #333;
  margin-bottom: 5px;
}

.back-link {
  color: #1C7EBB;
  text-decoration: none;
  margin-bottom: 15px;
  display: inline-block;
}

.event-form {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  padding: 25px;
  margin-bottom: 20px;
}

.form-group {
  margin-bottom: 15px;
}

label {
  display: block;
  margin-bottom: 5px;
  color: #555;
  font-weight: 500;
  font-size: 0.9em;
}

input, select {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 0.95em;
  font-family: inherit;
  box-sizing: border-box;
}

.entity-selector {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  margin-top: 8px;
}

.entity-option {
  padding: 10px;
  border: 2px solid #ddd;
  border-radius: 4px;
  text-align: center;
  cursor: pointer;
}

.entity-option.selected {
  border-color: #1C7EBB;
  background: #e3f2fd;
}

.entity-option input[type="radio"] {
  display: none;
}

.grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0 20px;
}

.grid .form-group.full {
  grid-column: 1 / -1;
}

button[type="submit"] {
  background: #1C7EBB;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 4px;
  font-size: 1em;
  cursor: pointer;
}

button[type="submit"]:disabled {
  background: #ccc;
  cursor: not-allowed;
}

.result {
  margin-top: 15px;
  padding: 15px;
  border-radius: 4px;
}

.result.success {
  background: #d4edda;
  border: 1px solid #c3e6cb;
  color: #155724;
}

.result.error {
  background: #f8d7da;
  border: 1px solid #f5c6cb;
  color: #721c24;
}

.muted {
  color: #888;
  font-size: 0.85em;
  margin-left: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/test-events/password/TestEventsPasswordCmp.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;EACrC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB","sourcesContent":[".container {\n  max-width: 900px;\n  margin: 0 auto;\n}\n\n.header {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n  padding: 20px 30px;\n  margin-bottom: 20px;\n}\n\n.header h1 {\n  color: #333;\n  margin-bottom: 5px;\n}\n\n.back-link {\n  color: #1C7EBB;\n  text-decoration: none;\n  margin-bottom: 15px;\n  display: inline-block;\n}\n\n.event-form {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n  padding: 25px;\n  margin-bottom: 20px;\n}\n\n.form-group {\n  margin-bottom: 15px;\n}\n\nlabel {\n  display: block;\n  margin-bottom: 5px;\n  color: #555;\n  font-weight: 500;\n  font-size: 0.9em;\n}\n\ninput, select {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 0.95em;\n  font-family: inherit;\n  box-sizing: border-box;\n}\n\n.entity-selector {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 10px;\n  margin-top: 8px;\n}\n\n.entity-option {\n  padding: 10px;\n  border: 2px solid #ddd;\n  border-radius: 4px;\n  text-align: center;\n  cursor: pointer;\n}\n\n.entity-option.selected {\n  border-color: #1C7EBB;\n  background: #e3f2fd;\n}\n\n.entity-option input[type=\"radio\"] {\n  display: none;\n}\n\n.grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 0 20px;\n}\n\n.grid .form-group.full {\n  grid-column: 1 / -1;\n}\n\nbutton[type=\"submit\"] {\n  background: #1C7EBB;\n  color: white;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 4px;\n  font-size: 1em;\n  cursor: pointer;\n}\n\nbutton[type=\"submit\"]:disabled {\n  background: #ccc;\n  cursor: not-allowed;\n}\n\n.result {\n  margin-top: 15px;\n  padding: 15px;\n  border-radius: 4px;\n}\n\n.result.success {\n  background: #d4edda;\n  border: 1px solid #c3e6cb;\n  color: #155724;\n}\n\n.result.error {\n  background: #f8d7da;\n  border: 1px solid #f5c6cb;\n  color: #721c24;\n}\n\n.muted {\n  color: #888;\n  font-size: 0.85em;\n  margin-left: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
